import React from 'react'
import EditFlightOfferWorker from './edit'
import { Link, withRouter } from 'react-router-dom'
import FlightOfferForm from '../components/form/form.component'
import FormHelper from '../../../../utils/FormHelper'
import './edit.styles.scss'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'

class EditFlightOffer extends React.Component {

    constructor(props) {
        super(props)
        this.editFlightOfferWorker = EditFlightOfferWorker(this)
        this.state = this.editFlightOfferWorker.getDefaultState()
    }

    componentDidMount(){
        this.editFlightOfferWorker.loadFlightOffer()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.editFlightOfferWorker.isValid() && this.editFlightOfferWorker.updateFlightOffer()
    }

    onCancel = () => this.props.history.push('/content/flight-offers')

    render() {
        return (
            <div className="edit-flight-offer">
                {
                    (this.state.loadingFlightOffer || this.state.updatingFlightOffer) && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/flight-offers">Flight Offers</Link>
                    <div className="header">
                        <h4>Edit Flight Offer</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <FlightOfferForm {...this.state} action="Save Flight Offer" onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel} />
                </div>
            </div>
        )
    }
}

export default withRouter(EditFlightOffer)
